import { useEffect } from "react";

const SITE = "Endeavour Castle Pune";
const ORIGIN = "https://pune.endeavourcastle.com";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, obj) {
  let el = document.getElementById(id);
  if (obj == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(obj);
}

export function useSEO({ title, description, path = "", image, jsonLd } = {}) {
  useEffect(() => {
    const fullTitle = title ? `${title} | ${SITE}` : `${SITE} | Pune Real Estate Discovery & Advisory`;
    document.title = fullTitle;
    const url = `${ORIGIN}${path || window.location.pathname}`;
    setMeta("name", "description", description);
    setLink("canonical", url);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:site_name", SITE);
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    if (image) setMeta("name", "twitter:image", image);
    setJsonLd("ec-jsonld", jsonLd || null);
    return () => setJsonLd("ec-jsonld", null);
  }, [title, description, path, image, JSON.stringify(jsonLd)]);
}

export const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "RealEstateAgent",
  name: "Endeavour Castle",
  description: "Pune-focused real estate advisory helping buyers and investors find residential, commercial and investment property across Pune.",
  areaServed: "Pune, Maharashtra, India",
  url: ORIGIN,
  telephone: "+91-9325271272",
  priceRange: "₹₹₹",
  address: { "@type": "PostalAddress", addressLocality: "Pune", addressRegion: "Maharashtra", addressCountry: "IN" },
};

export function graph(...objs) {
  return { "@context": "https://schema.org", "@graph": objs.filter(Boolean) };
}

export function breadcrumbJsonLd(items) {
  return {
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      ...(it.path ? { item: `${ORIGIN}${it.path}` } : {}),
    })),
  };
}

export function faqJsonLd(faqs) {
  return {
    "@type": "FAQPage",
    mainEntity: (faqs || []).map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}
